import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.DashboardPetPhoto = (function ($) {

    let $petPhoto = $('img[data-petid]');  
    let $petPhotoArr = [];

    function checkPetPhoto() {
        if ($petPhoto.length>0) {

            $($petPhoto).each((count,el) => {
                let petId = $(el).data('petid');

                if (petId == '') {
                    return;
                }

                if ($petPhotoArr.includes(petId) == true) {
                    return;
                }else{
                    $petPhotoArr.push(petId);
                }

                if (petId in localStorage) {
                    let imgBlob = localStorage.getItem(petId);

                    if (imgBlob !== '') {
                        $(`img[data-petid="${petId}"]`).each((idx,element) => {
                            $(element).attr('src','');
                            $(element).attr('src',imgBlob);
                        });
                    } 
                    
                    if (imgBlob == '') {
                        getPetPhoto(petId);
                    }
                } else {
                    getPetPhoto(petId);
                }
            });
        }
    }

    async function getPetPhoto(petId) {  
        localStorage.setItem(petId,'');

        const url = '/myvca-api/get-pet-photo';
        let api = new ApiService(url);
        let query = { petId };
        const { data, success, error } = await api.query(query);

        if (success) {
            if (data !== null && data !== '') {
                $(`img[data-petid="${petId}"]`).each((idx,el) => {
                    $(el).attr('src','');
                    $(el).attr('src',data);
                });
                localStorage.setItem(petId, data);
            }
        } else  {
            console.log("Error retrieving pet profile image: ", error);
        }
    }

    function init() {
        checkPetPhoto();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.DashboardPetPhoto.init();
    });
});